import * as api from "@/api/williams/scopesOfWork";
import { getFullPath, routes } from "../../routes";
import { queryKeys } from "../../queryKeys";
import { ScopeOfWork } from "@/api/williams/scopesOfWork";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { usePinScope } from "./usePinScope";

export function useSaveScope() {
  const queryClient = useQueryClient();
  const pinScope = usePinScope();
  const navigate = useNavigate();

  return useMutation(async (scope: ScopeOfWork) => {
    const response = await api.saveScopeOfWork(scope);
    const updatedScope = {
      ...response,
      // Remove time portion so it works with the HTML date input.
      reportDate: response.reportDate.substring(0, 10),
    };

    queryClient.setQueryData(queryKeys.scopeOfWork.single(response.id), updatedScope);
    queryClient.invalidateQueries(queryKeys.scopeOfWork.list());

    if (window.location.href.endsWith(routes.scopeOfWork.create)) {
      // Automatically add new SOW to favorites.
      pinScope.mutate(updatedScope.id);

      // Redirect from /new to the actual created SOW.
      navigate(getFullPath(routes.scopeOfWork.open(response.id)), {
        replace: true,
        state: {
          skipSavePrompt: true,
        },
      });
    }

    return updatedScope;
  });
}
